import { NaviTableColumnDef } from '@cp/src/components/NaviTable/interfaces';
import { ValidationData } from '../../../interface';
import { DateFormat } from '@cp/src/utils/DateHelper';
import dayjs from 'dayjs';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { DownloadIcon } from '@navi/web-ui/lib/icons';
import InputState from '../TimelineData/InputState';
import FailedAvatarIcon from '@cp/src/assets/icons/FailedAvatarIcon';
import InProgressAvatarIcon from '@cp/src/assets/icons/InProgressAvatarIcon';
import DefaultAvatarIcon from '@cp/src/assets/icons/DefaultAvatarIcon';
import SuccessAvatarIcon from '@cp/src/assets/icons/SuccessAvatarIcon';
import RightHeader from '../Headers/RightHeader';
import LeftHeader from '../Headers/LeftHeader';
import MockAllocationStates from '../TimelineData/MockAllocationStates';
import { InformationType, InputValidationType, RightHeaderType } from '../../../types';
import { handleDownload } from '../utils';

export const inputStatusConfig = (showPreviousAllocation?: boolean) => {
  return {
    NOT_STARTED: {
      icon: <DefaultAvatarIcon />,
      component: (
        <InputState
          header={<LeftHeader title="Prepare Inputs" />}
          showPreviousAllocationDetails={showPreviousAllocation}
        />
      )
    },
    SUCCESS: {
      icon: <SuccessAvatarIcon />,
      component: (
        <InputState
          header={<LeftHeader title="Inputs ready" />}
          showMockAllocationDetails
          showTable
          showPreviousAllocationDetails={showPreviousAllocation}
        />
      )
    },
    IN_PROGRESS: {
      icon: <InProgressAvatarIcon />,
      component: (
        <InputState
          header={
            <>
              <LeftHeader title="Preparing inputs" />
              <RightHeader type={InformationType.TEXT} component={RightHeaderType.INPUT} />
            </>
          }
          showMockAllocationDetails
          showPreviousAllocationDetails={showPreviousAllocation}
        />
      )
    },
    FAILURE: {
      icon: <FailedAvatarIcon />,
      component: (
        <InputState
          header={<LeftHeader title="Failed to prepare inputs" />}
          showMockAllocationDetails
          showPreviousAllocationDetails={showPreviousAllocation}
        />
      )
    }
  };
};

export const mockAllocationStatusConfig = (showPreviousAllocation?: boolean) => {
  return {
    PENDING: {
      icon: <DefaultAvatarIcon />,
      component: (
        <MockAllocationStates
          header={
            <>
              <LeftHeader title="Mock allocation" />
              <RightHeader type={InformationType.TEXT} />
            </>
          }
          showPreviousAllocationDetails={showPreviousAllocation}
        />
      )
    },
    IN_PROGRESS: {
      icon: <InProgressAvatarIcon />,
      component: (
        <MockAllocationStates
          header={
            <>
              <LeftHeader title="Mock allocation in progress" />
              <RightHeader type={InformationType.TEXT} />
            </>
          }
          showMockAllocationDetails
          showPreviousAllocationDetails={showPreviousAllocation}
        />
      )
    },
    SUCCESS: {
      icon: <SuccessAvatarIcon />,
      component: (
        <MockAllocationStates
          header={<LeftHeader title="Mock allocation is ready" />}
          showMockAllocationDetails
          showTable
          showPreviousAllocationDetails={showPreviousAllocation}
        />
      )
    },
    FAILURE: {
      icon: <FailedAvatarIcon />,
      component: (
        <MockAllocationStates
          header={
            <>
              <LeftHeader title="Mock allocation failed" />
              <RightHeader type={InformationType.TEXT} />
            </>
          }
          showMockAllocationDetails
          showPreviousAllocationDetails={showPreviousAllocation}
        />
      )
    }
  };
};

export const columns: NaviTableColumnDef<ValidationData>[] = [
  {
    accessorKey: 'name',
    header: 'Validations',
    size: 200,
    cell: ({ row }) => row.original?.name || '-'
  },
  {
    accessorKey: 'lastUpdatedAt',
    header: 'Last Updated',
    size: 180,
    cell: ({ row }) => {
      const date = row.original?.metadata?.lastUpdatedAt;
      if (date) return dayjs(date).format(DateFormat.DD_MMM_hh_mm_A);
      return '-';
    }
  },
  {
    accessorKey: 'lastUpdatedBy',
    header: 'Updated By',
    size: 150,
    cell: ({ row }) => row.original?.metadata?.lastUpdatedBy || '-'
  },
  {
    accessorKey: 'comments',
    header: 'Comments',
    size: 250,
    cell: ({ row }) => {
      const key = row.original?.key;
      const fileName =
        key === InputValidationType.AGENCY_CAPPING
          ? 'Error report Agency Capping'
          : 'Error report Pincode Serviceability';
      const feedback = row.original?.comments;
      const color = row.original?.color;
      const errorReport = row.original?.errorReport;
      if (!feedback) return '-';
      return (
        <div className="flex flex-row items-center gap-3">
          <Typography variant="p3" color={color}>
            {feedback}
          </Typography>
          {errorReport && (
            <Button
              onClick={handleDownload(errorReport, fileName)}
              variant="text"
              className="text-center"
            >
              <DownloadIcon color="var(--blue-base)" height={20} width={20} />
            </Button>
          )}
        </div>
      );
    }
  }
];
